<template>
  <div class="y-selector" @mouseenter="isExpande = true" @mouseleave="isExpande = false">
    <div class="y-selector-value">
      <div class="y-selector-content">{{ selected }}</div>
      <i
        class="y-selector-arrow"
        :class="{ 'el-icon-arrow-down': !this.isExpande, 'el-icon-arrow-up': this.isExpande }"
      ></i>
    </div>
    <ul class="y-selector-option-list" v-show="this.isExpande">
      <li
        class="y-selector-option"
        v-for="(item, index) in options"
        :key="index"
        @click="handleClick(index)"
        :title="item"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    selectedValue: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      // selectedIndex: 0,
      isExpande: false,
    }
  },
  computed: {
    selected: function () {
      return this.options.length > 0 ? this.options[this.selectedValue] : "无可选项"
    },
  },
  mounted() {},
  methods: {
    handleClick(index) {
      this.selectedIndex = index
      this.isExpande = !this.isExpande
      this.$emit("handleSelect", index)
    },
  },
}
</script>

<style lang="scss">
.y-selector {
  user-select: none;
  position: relative;
  opacity: 0.5;
  &:hover {
    opacity: 0.8;
  }
  .y-selector-value {
    display: flex;
    align-items: center;
    padding: 2px 5px;
    height: 1.25em;
    line-height: 1.25em;
    border: 1px solid #eee;
    border-radius: 3px;
    .y-selector-arrow {
      font-weight: bold;
      margin-left: 10px;
      position: absolute;
      right: 5%;
    }
  }
  .y-selector-option-list {
    margin-top: 5px;
    position: absolute;
    top: 1.25em;
    left: 0;
    right: 0;
    max-height: 10vh;
    overflow: auto;
    & li {
      line-height: 1.25em;
      padding: 2px 5px;
    }
    // & li:not(:last-of-type) {
    //   border-bottom: 1px solid white;
    // }
    & li:hover {
      background-color: rgba(#fff, $alpha: 0.1);
    }

    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #293e79;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
      background-color: #0f1d44;
      border-radius: 3px;
    }
    border: 1px solid #eee;
    border-radius: 3px;
  }
}
</style>
